<template>
    <vs-col vs-lg="12" vs-sm="12" vs-xs="12" class="custom-fields-spacing">
      <vs-row>
        <vs-col vs-w="12" vs-w-lg="6" v-for="(text, index) in productCustomFields" :key="index">
          <div>
            <div class="mt-5 mb-6 w-full" v-if="text.type !== 'address'">
              <label class="font-normal">{{ text.label }} <span v-if="text.reqToSendRequest" class="mid-blue">*</span></label>
              <div v-if="text.type == 'dropdown'">
                <vs-select
                  v-validate="{ required: text.reqToSendRequest ? true : false }"
                  class="selectExample w-full"
                  v-model="text.value"
                  :name="`${text.customFieldId}`"
                  :data-vv-as="`${text.label}`">
                  <vs-select-item :key="i" :value="dropdown" :text="dropdown" v-for="(dropdown, i) in text.dropdownSelectFields"/>
                  <span class="text-danger text-sm" v-show="errors.has(`${text.customFieldId}`)">{{ errors.first(`${text.customFieldId}`) }}</span>
                </vs-select>
              </div>
              <div class="flex flex-col" v-else-if="text.type === 'file'">
                <input
                  type="file"
                  class="hidden"
                  v-validate="{ required: text.reqToSendRequest ? true : false, size: maxFileSize * 1024 }"
                  :name="`${text.customFieldId}`"
                  :data-vv-as="`${text.label}`"
                  accept=".pdf"
                  :ref="`uploadImgInputRef${index}`"
                  @change="updateCurrImg($event, index, text)"
                />
                <vs-button
                  v-if="!text.selectedFile"
                  v-round
                  class="only-border-btn mt-2"
                  size="small"
                  style="width: 126px"
                  @click="uploadImgInput(index)"
                >
                  Upload file
                </vs-button>
                <span v-if="text.selectedFile"  class="w-10/12 flex justify-between mt-5 items-center">
                  <a href="#">{{ text.selectedFile.name }}</a>
                  <p @click="removeFile(index,text)" class="bin-icon-margin">
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.6665 5.79606C1.6665 5.33582 2.0396 4.96273 2.49984 4.96273H17.4998C17.9601 4.96273 18.3332 5.33582 18.3332 5.79606C18.3332 6.2563 17.9601 6.62939 17.4998 6.62939H2.49984C2.0396 6.62939 1.6665 6.2563 1.6665 5.79606Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33317 3.29606C8.11216 3.29606 7.9002 3.38386 7.74392 3.54014C7.58763 3.69642 7.49984 3.90838 7.49984 4.12939V4.96273H12.4998V4.12939C12.4998 3.90838 12.412 3.69642 12.2558 3.54014C12.0995 3.38386 11.8875 3.29606 11.6665 3.29606H8.33317ZM14.1665 4.96273V4.12939C14.1665 3.46635 13.9031 2.83047 13.4343 2.36163C12.9654 1.89279 12.3295 1.62939 11.6665 1.62939H8.33317C7.67013 1.62939 7.03425 1.89279 6.5654 2.36163C6.09656 2.83047 5.83317 3.46635 5.83317 4.12939V4.96273H4.1665C3.70627 4.96273 3.33317 5.33582 3.33317 5.79606V17.4627C3.33317 18.1258 3.59656 18.7617 4.0654 19.2305C4.53424 19.6993 5.17013 19.9627 5.83317 19.9627H14.1665C14.8295 19.9627 15.4654 19.6993 15.9343 19.2305C16.4031 18.7617 16.6665 18.1258 16.6665 17.4627V5.79606C16.6665 5.33582 16.2934 4.96273 15.8332 4.96273H14.1665ZM4.99984 6.62939V17.4627C4.99984 17.6837 5.08763 17.8957 5.24392 18.052C5.4002 18.2083 5.61216 18.2961 5.83317 18.2961H14.1665C14.3875 18.2961 14.5995 18.2083 14.7558 18.052C14.912 17.8957 14.9998 17.6837 14.9998 17.4627V6.62939H4.99984Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33317 9.12939C8.79341 9.12939 9.1665 9.50249 9.1665 9.96273V14.9627C9.1665 15.423 8.79341 15.7961 8.33317 15.7961C7.87293 15.7961 7.49984 15.423 7.49984 14.9627V9.96273C7.49984 9.50249 7.87293 9.12939 8.33317 9.12939Z" fill="#757575"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6665 9.12939C12.1267 9.12939 12.4998 9.50249 12.4998 9.96273V14.9627C12.4998 15.423 12.1267 15.7961 11.6665 15.7961C11.2063 15.7961 10.8332 15.423 10.8332 14.9627V9.96273C10.8332 9.50249 11.2063 9.12939 11.6665 9.12939Z" fill="#757575"></path></svg>
                  </p>
                </span>
                <div class="text-danger text-sm pt-1" v-show="errors.has(`${text.customFieldId}`)">{{ errors.first(`${text.customFieldId}`) }}</div>
              </div>
              <div v-else-if="text.type === 'currency'">
                <money
                  v-validate="{ customCurrency: text.reqToSendRequest ? true : false }"
                  :name="`${text.customFieldId}`"
                  :data-vv-as="`${text.label}`"
                  v-model="text.value"
                  class="w-full"
                  v-bind="moneyMask"
                  @input.native="checkForm"
                />
                <span class="text-danger text-sm" v-show="errors.has(`${text.customFieldId}`)">{{ errors.first(`${text.customFieldId}`) }} </span>
              </div>
              <div v-else-if="text.type === 'date'">
                <date-picker
                  v-validate="{ required: text.reqToSendRequest ? true : false }"
                  :name="`${text.customFieldId}`"
                  :data-vv-as="`${text.label}`"
                  v-model="text.value"
                  lang="en"
                  type="date"
                  placeholder="DD/MM/YYYY"
                  class="w-full customdate"
                  format="DD/MM/YYYY"
                  :disabled-days="disabledDate(text)"
                ></date-picker>
                <span class="text-danger text-sm" v-show="errors.has(`${text.customFieldId}`)">{{ errors.first(`${text.customFieldId}`) }}</span>
              </div>
              <div v-else>
                <vs-input
                  v-validate="{ required: text.reqToSendRequest ? true : false }"
                  :type="text.type"
                  class="w-full"
                  size="large"
                  :name="`${text.customFieldId}`"
                  :data-vv-as="`${text.label}`"
                  v-model="text.value"
                  @input="checkForm"
                />
                <span class="text-danger text-sm" v-show="errors.has(`${text.customFieldId}`)">{{ errors.first(`${text.customFieldId}`) }}</span>
              </div>
            </div>
            <div class="my-5" v-else>
              <label class="font-normal block mb-5">{{ text.label }} <span v-if="text.reqToSendRequest" class="mid-blue">*</span></label>
              <div class="mb-5">
                <div class="w-full">
                  <vue-google-autocomplete
                    ref="address"
                    :id="index.toString()"
                    classname="w-full custom-w"
                    v-on:placechanged="getAddressData"
                    :country="['au']"
                    placeholder="Start typing your address">
                  </vue-google-autocomplete>
                </div>
              </div>
              <div class="mb-5">
                <div class="w-full custom-mt pr-xs-0 lg:mt-0 sm:mt-5">
                  <label class="text-base font-light w-full">Apt, Suite, Unit, Building, Floor</label>
                  <vs-input class="w-full custom-w vs-input--input" v-model="text.addr.unit_number" name="unit_number"/>
                  <span class="text-danger text-sm" v-show="errors.has('unit_number')">{{ errors.first("unit_number") }}</span>
                </div>
              </div>
              <div class="mb-5">
                <div class="w-full custom-mt">
                  <label class="text-base font-light w-auto">Street address</label>
                  <span class="text-danger text-sm" v-show="errors.has(`street_name[${index}]`)">{{ errors.first(`street_name[${index}]`) }}</span>
                  <vs-input
                    class="w-full custom-w add-street vs-input--input"
                    v-model="text.addr.street_name"
                    :name="`street_name[${index}]`"
                    v-validate="{ required: text.reqToSendRequest ? true : false }"
                    data-vv-as="street name"
                  />
                </div>
              </div>
              <div class="mb-5">
                <div class="w-full custom-mt">
                  <label class="text-base font-light">Suburb</label>
                    <span class="text-danger text-sm" v-show="errors.has(`suburb[${index}]`)">{{ errors.first(`suburb[${index}]`) }}</span>
                    <vs-input
                      class="w-full custom-w vs-input--input"
                      v-model="text.addr.suburb"
                      :name="`suburb[${index}]`"
                      data-vv-as="name"
                      v-validate="{ required: text.reqToSendRequest ? true : false }"
                    />
                </div>
              </div>
              <div class="mb-5 pf-add-info-force flex flex-row justify-between">
                <div class="custom-mt w-5/12">
                  <label class="w-full text-base font-light">State</label>
                  <div class="input-container">
                    <span class="text-danger text-sm" v-show="errors.has(`state[${index}]`)">{{ errors.first(`state[${index}]`) }}</span>
                    <vs-select
                      autocomplete
                      v-model="text.addr.state"
                      class="w-full custom-w"
                      :name="`state[${index}]`"
                      data-vv-as="state"
                      v-validate="{ required: text.reqToSendRequest ? true : false }"
                      placeholder="Select state">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in states" ></vs-select-item>
                    </vs-select>
                  </div>
                </div>
                <div class="custom-mt w-5/12">
                  <label class="w-full text-base font-light">Postcode</label>
                  <div class="input-container">
                    <span class="text-danger text-sm" v-show="errors.has(`postcode[${index}]`)">{{ errors.first(`postcode[${index}]`) }}</span>
                    <the-mask
                      class="w-full custom-w vs-input--input"
                      type="text"
                      masked
                      :mask="['####']"
                      v-model="text.addr.postcode"
                      :name="`postcode[${index}]`"
                      data-vv-as="postcode"
                      v-validate="{ required: text.reqToSendRequest ? true : false }"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
</template>

<script>
import { TheMask } from "vue-the-mask";
import { Money } from "v-money";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { Validator } from "vee-validate";
import DatePicker from "vue2-datepicker";

export default {
  components: {
    TheMask,
    VueGoogleAutocomplete,
    Money,
    DatePicker,
  },
  props: ["isSubmitted", "productCustomFields", "productFieldErrors"],

  data() {
    return {
      pfFiles: [],
      pf: "",
      productAddressFieldArray: {},
      productAddressField: {
        unit_number: "",
        street_number: "",
        street_name: "",
        suburb: "",
        state: "",
        street_type: "",
        postcode: "",
        country: "",
      },
      states: [
        { text: "NSW", value: "NSW" },
        { text: "ACT", value: "ACT" },
        { text: "QLD", value: "QLD" },
        { text: "VIC", value: "VIC" },
        { text: "NT", value: "NT" },
        { text: "SA", value: "SA" },
        { text: "WA", value: "WA" },
        { text: "TAS", value: "TAS" },
      ],
      addressData: "",
      moneyMask: {
        thousands: ",",
        prefix: "$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      maxFileSize: process.env.VUE_APP_FILE_MAX_SIZE_MB,
    };
  },
  watch: {
    async isSubmitted(value) {
      this.startValidating();
    },

    productFieldErrors(newVal, oldVal) {
      this.productFieldValidator(newVal);
    }
  },

  computed: {
    validateForm() {
      return !this.errors.any();
    },

    user() {
      return this.$store.state.AppActiveUser;
    },

    partnerId() {
      return this.user.userType === "admin"
        ? this.user._id
        : this.user.partnerId;
    },
  },

  methods: {
    productFieldValidator(errors) {
      errors.forEach((err) => {
        if (err.criteria == "MAX_PERCENT_OF_PRODUCT_FIELD") {
          this.$emit("maxPercentageError", err);
        } else if (err.criteria == "PRODUCT_FIELD_AS_DUE_DATE") {
          this.errors.add({ field: err.productFieldId, msg: err.errorMsg });
        } else {
          this.errors.add({ field: err.productFieldId, msg: err.errorMessage });
        }
      });
    },

    disabledDate(data) {
      return (date) => this.disableSpecificDays(date, data);
    },

    disableSpecificDays(date, data) {
      if (!data || !data.validationWhenSendingRequests || !data.validationWhenSendingRequests.length) {
        return false;
      }

      const inFutureDateValidation = data.validationWhenSendingRequests.find(item => item.dateMustBe == "IN_FUTURE");

      if (!inFutureDateValidation) {
        return false;
      }

      let today = new Date();
      let dateHere = new Date();

      dateHere.setDate(dateHere.getDate() + parseInt(inFutureDateValidation.noOfDays));

      if (inFutureDateValidation.additionalRule == "LESS_THAN") {
        return date < today || date > dateHere;
      } else if (inFutureDateValidation.additionalRule == "MORE_THAN") {
        return date < dateHere;
      } else {
        return date < today;
      }
    },

    getAddressData: function (addressData, placeResultData, myIdIdx) {
      let addrArray = [];

      if (addressData.street_number) {
        this.productCustomFields[myIdIdx].addr.street_number = addressData.street_number;
      }

      if (addressData.postal_code) {
        this.productCustomFields[myIdIdx].addr.postcode = addressData.postal_code;
      }

      if (addressData.locality) {
        this.productCustomFields[myIdIdx].addr.suburb = addressData.locality;
      }

      if (addressData.administrative_area_level_1) {
        this.productCustomFields[myIdIdx].addr.state = addressData.administrative_area_level_1;
      }

      if (addressData.route) {
        let street_address = "";
        for (const address of placeResultData.address_components) {
          if (address.types.includes("street_number"))
            street_address += address.short_name + " ";

          if (address.types.includes("route"))
            street_address += address.long_name;
        }
        this.productCustomFields[myIdIdx].addr.street_name = street_address;
        addrArray.push(street_address);
      }

      if (addressData.locality && addressData.administrative_area_level_1){
        let state = addressData.locality+" "+addressData.administrative_area_level_1;
        addrArray.push(state);
      }

      if (addressData.country) {
        this.productCustomFields[myIdIdx].addr.country = addressData.country;
        addrArray.push(addressData.country)
      }

      this.productCustomFields[myIdIdx].value = addrArray.join(',');
    },
    getAddressData1: function (addressData, placeResultData, _id) {
      this.addressData = addressData;

      if (this.addressData.street_number) {
        this.productAddressFieldArray[_id].street_number =
          this.addressData.street_number;
      }

      if (this.addressData.postal_code) {
        this.productAddressFieldArray[_id].postcode = this.addressData.postal_code;
      }

      if (this.addressData.locality) {
        this.productAddressFieldArray[_id].suburb = this.addressData.locality;
      }

      if (this.addressData.administrative_area_level_1) {
        this.productAddressFieldArray[_id].state = this.addressData.administrative_area_level_1;
      }

      if (addressData.route) {
        let street_address = "";

        for (const address of placeResultData.address_components) {
          if (address.types.includes("street_number")) {
            street_address += address.short_name + " ";
          }

          if (address.types.includes("route")) {
            street_address += address.long_name;
          }
        }

        this.productAddressFieldArray[_id].street_name = street_address;
      }
    },
    async startValidating() {
      await this.$validator.validate();
    },
    validateChildForm() {
      return this.$validator.validateAll();
    },
    checkForm() {
      this.$emit("checkForm");
    },
    uploadImgInput(key) {
      this.$refs[`uploadImgInputRef${key}`][0].click();
    },
    updateCurrImg(input, key, fieldRow) {
      let file = input.target.files[0];
      fieldRow.selectedFile = file;
    },
    removeFile(key, fieldRow) {
      if (fieldRow.hasOwnProperty('value') && fieldRow.value.length > 0) {
        fieldRow.value = "";
      }
      this.$refs[`uploadImgInputRef${key}`][0].value = "";
      if (this.productCustomFields[key].hasOwnProperty("selectedFile") && typeof this.productCustomFields[key].selectedFile === 'object') {
        this.$delete(this.productCustomFields[key], 'selectedFile');
      }
      if (this.errors.has(fieldRow.label)) {
        this.errors.remove(fieldRow.label);
      }
    }
  },
  created() {
    Validator.extend("customCurrency", {
      getMessage: (field) => "Currency input is required",
      validate(value) {
        return new Promise(resolve => {
          resolve({
            valid: value <= 0 ? false : !! value,
            data: value > 0 ? undefined : { message: 'Not this value' }
          });
        });
      }
    });
  },
};
</script>
